import { render } from "./Report2.vue?vue&type=template&id=793b8a3c&scoped=true"
import script from "./Report2.vue?vue&type=script&lang=js"
export * from "./Report2.vue?vue&type=script&lang=js"

import "./Report2.vue?vue&type=style&index=0&id=793b8a3c&lang=scss&scoped=true"

import exportComponent from "/Users/alexeysorokin/Desktop/hexp2/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793b8a3c"]])

export default __exports__